<app-header></app-header>
<ng-container *ngIf="loading$ | async">
	<div class="overlay"></div>
	<mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </ng-container>
<router-outlet></router-outlet>
<app-footer></app-footer>